import angular from 'angular';
import paymentHistoryComponent from './payment-history.component';
import PaymentHistoryService from './payment-history.service';
import paymentHistoryConfig from './payment-history.config';

let paymentHistoryModule = angular.module('app.reports.payment-history',[])
  .component('reportPaymentHistory', paymentHistoryComponent)
  .service('reportPaymentHistoryService', PaymentHistoryService)
  .config(paymentHistoryConfig);

export default paymentHistoryModule;



/** WEBPACK FOOTER **
 ** ./www/components/reports/payment-history/payment-history.js
 **/